import { createContext } from "react";

export const ThemeContext = createContext({
  resetTheme: (): void => undefined,
});
